import { FileCommand } from 'app/projects/core/src/lib/models/file.command';

export class UnsplashImageUploadCommand extends FileCommand {
    constructor(photoId: string, file: File) {
        super('file', file);

        this.formData.append('photo_id', photoId);
    }
}
